module.exports = __webpack_public_path__ + "img/10.09decf83.png";